import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getRiskLevels } from '@api/lookups';
import { IRiskLevel } from '@interfaces/riskLevels';

export const handleGetRiskLevels = createAsyncThunk<AxiosResponse<IRiskLevel[]>, void>(
  'getRiskLevels',
  getRiskLevels,
);
